module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.16.0.0.box.448.624.798.95.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.16.0.0.box.448.624.798.95.q.90"
    }
  }, [_vm._v("The Cajun Story")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.170.997.1352.1285.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.0.box.171.997.1351.418.q.60"
    }
  }, [_vm._v("Wherever I go across the country, people ask me, \"Just what is a Cajun?\" The word "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cajun ")]), _vm._v("is a corruption of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Acadian. ")]), _vm._v("The Acadians were the French people living in old "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Acadie ")]), _vm._v("(now Nova Scotia) who were expelled forcibly from Canada by the British in the 1750s and 1760s. Of all Louisianians of French origin, the Cajuns are just a part. Not all people living in Louisiana are Cajuns. The term should only be applied to the descendants of those Acadians who were driven from Canada.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.170.1434.1351.579.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.1.0"
    }
  }), _vm._v("That era was a terrible time for my ancestors. They had gone to Canada seeking a new and better life—free land, the ability to live as they chose, and the freedom to practice their religion. Their reasons for coming to North America were all valid and were soon all realized. They etched out an existence that was comfortable for them, but by no means lavish. They were hard workers and earned all they had by the sweat of their brows. The society they formed bothered no one, and they generally kept to themselves. Happenings in the American Colonies didn't concern them, nor did the war between Britain and France. Building hope and a future for their children was their goal and their priority.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.2.box.170.2022.1350.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.2.0"
    }
  }), _vm._v("As the world political situation deteriorated, the Acadians were faced with a crisis. The treaty that ended the war gave Acadie to England, and the British demanded that the Acadians swear a loyalty oath to the King of England and the Anglican Church. The French crown held no special place in the Acadians' hearts or lives, but they"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.0.0.box.171.249.1349.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _vm._v("\nwere French people. Their religion was very important to them; they were Catholic and would not consider any other religion. To these proud Acadians, such a loyalty oath was incomprehensible. Giving up their property and all earthly possessions, as tragic as it was, was their only option.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.0.0.box.171.249.1351.2041.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.1.box.171.522.1350.421.q.60"
    }
  }, [_vm._v("The British Empire was not satisfied with this peaceful settlement. They took an even crueler approach in expelling the Acadians. Families were deliberately split—husband from wife, mother from child, brother from sister, all shipped off to various ports and destinations. Many families were never again united. The agony that the British caused was never to be forgiven or forgotten. It became a part of the Cajun soul. Never again would a Cajun completely trust government, politics, or the opinions of outsiders.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.2.box.172.954.1350.580.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.2.0"
    }
  }), _vm._v("Cajun settlements were set up all across the Atlantic seaboard and inland as well. Most Cajuns eventually made their way to Louisiana, where the French had settled 100 years earlier. So, Cajuns were not the first French in Louisiana. Some tried the life in New Orleans and attempted to assimilate into the New Orleans Creole way of life. For the most part, that did not work; they were not the same people. The Cajuns' culture had remained close to the French Provincial way of life of the early 1600s. In Canada they adjusted their ways, took some ideas, but their language and lifestyle remained those of 17th-century France. The ways of the Creole French were as foreign to them as were the ways of the American colonists.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.3.box.172.1543.1350.582.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.3.0"
    }
  }), _vm._v("Most of the Cajuns, then, went to the bayou country of Southwest Louisiana. There they developed a closed culture that cut them off from the outside world. Their own world developed separately from the rest of the state and country. Geography helped; there was no way to travel through the area except by bayou or a few very poor trails. Therefore they learned to depend on their families and on close, trusted neighbors. In addition, their experiences in the past with outsiders, foreign countries, and non-Cajuns had not been rewarding, to say the least. They trusted only each other. They could depend only on each other. Their way of life continued and was nurtured by the lavish bayou systems of Southern Louisiana.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.0.4.box.173.2135.1348.155.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.4.0"
    }
  }), _vm._v("No longer was their life cruel. They now had very fertile land, an excellent climate, a long growing season, and above all an abundance of fresh food (seafood, game, and meat). Perhaps the physical"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.0.0.box.171.272.1352.323.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _vm._v("\nconditions of the bayou country kept them from becoming well-todo, but the bayous also provided rich culinary delights. Dishes fit for royalty were everyday fare. Food was a commodity all had in abundance. In style, the cooking had French roots but developed into a unique form because of the availability of new foods and spices.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.1.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.0.0.box.170.272.1353.755.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.0.1.box.170.605.1353.422.q.60"
    }
  }, [_vm._v("Cajun cooking is a unique blend of fresh ingredients, pungent spices, and creativity. It is as unique as each of its practitioners. The land created within the Cajun people a love of food and an ability to cook from the soul, not just from the pot. As a people we can draw from a varied background: France, Canada, Creole New Orleans, and our own Bayou Country. Cajun cooking is exciting, yet simple and basic. Let your palate be your guide. To cook like a Cajun is to live a little closer to heaven on earth!")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c45ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0008.vue
// module id = 60
// module chunks = 0